import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Markets from './pages/Markets';
import Presence from './pages/Presence';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/markets" element={<Markets />} />
            <Route path="/markets/:slug" element={<Markets />} />
            <Route path="/presence" element={<Presence />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
